/* eslint-disable */
import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      marginBottom: 50,
      marginTop: 64,
    },
    box: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      border: "1px solid",
      borderColor: "grey",
      borderRadius: "10px",
      width: "500px",
      height: "min-content",
      padding: "24px",
      margin: "32px 0",
      position: "relative",
    },
    loginGroup: {
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch",
      justifyContent: "space-evenly",
      width: "100%",
    },
    header: {
      marginBottom: "12px",
    },
    textField: {
      position: "relative",
      marginBottom: "12px",
    },
    helperText: {
      position: "absolute",
      bottom: "-22px",
      whiteSpace: "nowrap",
      width: "100%",
      textOverflow: "ellipsis",
      overflow: "hidden",
      color: "#f44336",
    },
    domain: {
      minWidth: "200px",
    },
    department: {
      minWidth: "448px",
      marginLeft: "-6px",
    },
    buttonBase: {
      margin: "16px 0px",
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    registerButton: {
      display: "flex",
      flex: "1 1 50%",
      textTransform: "capitalize",
    },
    cancelButton: {
      textTransform: "capitalize",
      backgroundColor: "#004a96",
      width: "100%",
    },
    link: {
      color: "#fff",
      border: "none",
      "&:hover": {
        border: "none",
      },
      display: "flex",
      flex: "1 1 50%",
      marginLeft: theme.spacing(2),
    },
    errorTypo: {
      color: "red",
      position: "absolute",
      bottom: 8,
    },
    inputLabel: {
      color: theme.palette.primary.main,
    },
    selectInput: { width: 0 },
    textInput: {},
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.primary.main,
    },
    inputRoot: {
      "-webkit-box-shadow": "0 0 0px 1000px #f6f8f7 inset",
    },
    menuOption: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.1)",
      },
    },
  });
